import React from 'react';

import { Preloader, Oval } from 'react-preloader-icon';

const Loader = () => (
    <Preloader use={Oval} size={24} strokeWidth={8} strokeColor="#ffffff" duration={800} style={{ margin: '0 auto', padding: '0px' }} />
);

export default function PreloadButton({ isLoad, disabled, ...props }) {
    const style = {
        border: isLoad ? 'none' : undefined,
        padding: isLoad ? '8px 5em' : undefined,
        background: isLoad ? '#ffaaaa' : undefined,
        opacity: disabled ? 0.3 : 1,
        transition: 0,
    };

    return (
        <button className="login-form__login-btn custom-btn" style={style} disabled={isLoad} {...props}>
            {isLoad ? <Loader /> : props.children}
        </button>
    );
}
